import $ from "jquery";
import { API } from "./api";
import { GlobalVariables as gv, GlobalFunctions as gf, URLCriteriaHelper, SavedSearchResult } from "./data";
import { Params } from "./data-structures";
import usaj_ga from '../Analytics/usaj-analytics'

interface termHighlighter {
    (s: string, t: string): any;
}

declare var usajSrcHighlighter: any;
declare var keywordSrcHighlighter: any;
declare function logLocationAC(selectedTerm: string): void;
declare function logKeywordAC(selectedTerm: string): void;
declare var termHighlighter: termHighlighter;
var viewport_width = window.innerWidth;

export class Events {
    setupEvents() {

		$('form').submit(function (event) {
            event.preventDefault();
		});

        $(document).on("click", ".usajobs-search-pagination__previous-page, .usajobs-search-pagination__next-page", function (e) {
            e.preventDefault();
            var params = gv.getParams();
            if ($(this).hasClass("usajobs-search-pagination__previous-page")) {
                params.Page = (parseInt($(this).closest(".usajobs-search-pagination").find(".is-active").text()) - 1).toString();
            } else {
                params.Page = (parseInt($(this).closest(".usajobs-search-pagination").find(".is-active").text()) + 1).toString();
            }
            gv.setParams(params);
            gf.display(API.current.GetResults(gv.getParams()), gv.getTemplates(), "usajobs-search-result-0");
            URLCriteriaHelper.ConstructURL(gv.getParams(), gv.getAliasMapping());
            gf.goToByClassName("usajobs-site-header");
        });

        $(document).on("click", ".usajobs-search-pagination__page:not(.is-active)", function (e) {
            e.preventDefault();
            var params = gv.getParams();
            params.Page = $(this).text().trim();
            gv.setParams(params);
            gf.display(API.current.GetResults(gv.getParams()), gv.getTemplates(), "usajobs-search-result-0");
            URLCriteriaHelper.ConstructURL(gv.getParams(), gv.getAliasMapping());
            gf.goToByClassName("usajobs-site-header");
        });

        $(document).on("click", ".usajobs-search-filters__select-toggle", function (e) {
            e.preventDefault();
            var linkText = $(this).text().trim();
            var filter = $(this).data('name');
            var params = gv.getParams(); 
            params.Page = "1";
            if (linkText == 'Select all') {
                $(this).text('Deselect all');
                gf.selectAllFiltersByType(filter, params);
                gv.setParams(params);
                gf.display(API.current.GetResults(gv.getParams()), gv.getTemplates(), e.target.id);
            }
            else {
                $(this).text('Select all');
                gf.deselectAllFiltersByType(filter, params);
                gv.setParams(params);
                gf.display(API.current.GetResults(gv.getParams()), gv.getTemplates(), e.target.id);
            }
            URLCriteriaHelper.ConstructURL(gv.getParams(), gv.getAliasMapping());
        });

        $(document).on("click", ".usajobs-nav__search-button", function (e) {
            $('#nav-keyword').blur();
            $('#nav-location').blur();

            var params = gv.getParams();
            var newKeyword = $("#nav-keyword").val() as string;
            var newLocation = $("#nav-location").val() as string;
            if (newKeyword) {
                params.Keyword  = newKeyword;
            }
            else {
                delete params.Keyword;
            }

            if (newLocation) {
                if ("remote" === newLocation.toLowerCase()) {
                    params.RemoteIndicator = true;
                    gf.removeFilterPill("exclude_remote");
                } else {
                    params.LocationName.push(newLocation);
                }
            }
            params.Page = "1";
            gv.setParams(params);
            $("#nav-location").val('');
            gf.display(API.current.GetResults(gv.getParams()), gv.getTemplates());
            URLCriteriaHelper.ConstructURL(gv.getParams(), gv.getAliasMapping());
        });

        $(document).on("change", "#nav-keyword", function () {
            var params:Params = gv.getParams();
            var keyword = $(this).val() as string;
            if (keyword === "") {
                delete params.Keyword;
            } else {
                keyword = gf.padKeyword(keyword);
                params.Keyword = keyword;
                $(this).val(keyword);
            }
            gv.setParams(params);
        });

        $(document).on("click", ".usajobs-search-result--core__save-job-link", function (e) {
            var saved_state = $(this).attr('data-state');
            let userObject = JSON.parse(sessionStorage.getItem('userObject') ?? "");
            $(this).blur();
           e.preventDefault();
            if (saved_state === 'is-saved') {
                $(this).find('span').text('Save Job');
                $(this).attr('data-state', 'is-unsaved');
                API.current.DeleteSavedJob($(this).data("id"));
                delete userObject.SavedJobs[$(this).data("id")];
            } else {
                if (Object.keys(userObject.SavedJobs).length >= 25) {
                    $('.overSavedJobLimitError').show();
                    gf.goToByClassName("overSavedJobLimitError");
                } else {
                    $(this).find('span').text('Saved');
                    $(this).attr('data-state', 'is-saved');
                    API.current.AddSavedJob($(this).data("id"));
                    userObject.SavedJobs[$(this).data("id")] = true
                }
            }
			sessionStorage.setItem("userObject", JSON.stringify(userObject));
        });

        $(document).on("change", ".usajobs-search-controls__sort-control", function (e) {
            var params = gv.getParams();
            var sortField = "";
            if (($(this).val() != "asc") && ($(this).val() != "desc")) {
                sortField = $(this).val() as string;
            } else {
                sortField = $('#sort_attribute').val() as string;
            }
            params.SortField = sortField;
            params.SortDirection = (($(this).val() == "asc") || ($(this).val() == "desc")) ? $(this).val() as string : "asc";

            params.Page = "1";
            gv.setParams(params);

            //set mobile sort dropdown
            $('#sort_attribute_mobile').val(params.SortField);

            gf.display(API.current.GetResults(gv.getParams()), gv.getTemplates(), e.target.id);
            URLCriteriaHelper.ConstructURL(gv.getParams(), gv.getAliasMapping());
        });

        $(document).on("change", ".usajobs-search-controls__sort-control-mobile", function (e) {
            var params = gv.getParams();
            var sortField = "";
            if (($(this).val() != "asc") && ($(this).val() != "desc")) {
                sortField = $(this).val() as string;
            } else {
                sortField = $('#sort_attribute').val() as string;
            }
            params.SortField = sortField;
            params.SortDirection = (($(this).val() == "asc") || ($(this).val() == "desc")) ? $(this).val() as string : "asc";

            params.Page = "1";
            gv.setParams(params);

            //set sort dropdown
            $('#sort_attribute').val(params.SortField);

            gf.display(API.current.GetResults(gv.getParams()), gv.getTemplates(), e.target.id);
            URLCriteriaHelper.ConstructURL(gv.getParams(), gv.getAliasMapping());
        });


        $(document).on("click", ".usajobs-alert__close", function (e) {
            e.preventDefault();
            $(this).closest(".usajobs-alert").slideUp();
        });

        $(document).on("change", ".search-filter-update", function (e) {
            var params = gv.getParams();
            var aliasMapping = gv.getAliasMapping();
            var filter = $(this);
            var filterID = filter.attr("id");
            var propertyToUpdate = aliasMapping[filter.attr("name")!].JOAQueryName;
            if (filter.is(':checked')) {
                let isRemoteSelected = params.RemoteIndicator !== undefined && params.RelocationIndicator !== null;
                if (params[propertyToUpdate] instanceof Array) {
                    params[propertyToUpdate].push(filter.data('id').toString());
                } else {
                    params[propertyToUpdate] = filter.data('id');
                }
                if (filterID === "only_remote" && isRemoteSelected) {
                    gf.removeFilterPill("exclude_remote");
                }
                if (filterID === "exclude_remote" && isRemoteSelected) {
                    gf.removeFilterPill("only_remote");
                }
                gf.addFilterPill($(this));    
            }
            else {
                if (params[propertyToUpdate] instanceof Array) {
                    params[propertyToUpdate] = $.grep(params[propertyToUpdate], function (value) {
                        return value?.toString().toLowerCase() != filter.data('id').toString().toLowerCase();
                    });
                } else {
                        delete params[propertyToUpdate];                    
                }
                gf.removeFilterPill($(this).attr('id'));
            }
            params.Page = "1";
            gv.setParams(params);
            gf.display(API.current.GetResults(gv.getParams()), gv.getTemplates(), e.target.id);
            URLCriteriaHelper.ConstructURL(gv.getParams(), gv.getAliasMapping());
        });

        $(document).on("search-pills.remove", "[data-object='search-pills']", function (event, opts) {
            if ($(opts.el).hasClass("usajobs-branded-search-pills")) {
                return;
            }
            var target_id = $(opts.el).data("target-id");
            if (target_id.indexOf("loc_") >= 0) {
                var location = $(opts.el).find(".search-pill-name").text();
                var params = gv.getParams();
                var index = params.LocationName.indexOf(location);
                if (index > -1) {
                    params.LocationName.splice(index, 1);
                    params.Page = "1";
                    if (params.LocationName.length === 0) delete params.Radius;
                    gv.setParams(params);
                    gf.display(API.current.GetResults(gv.getParams()), gv.getTemplates());
                    URLCriteriaHelper.ConstructURL(gv.getParams(), gv.getAliasMapping());
                }
                gf.removeFilterPill(target_id);
            } else if (target_id.indexOf("soc_") >= 0) {
                var standardOccupation = $(opts.el).find(".search-pill-name").text();
                var params = gv.getParams();
                var index = params.SocTitle.indexOf(standardOccupation);
                if (index > -1) {
                    params.SocTitle.splice(index, 1);
                    params.Page = "1";
                    gv.setParams(params);
                    gf.display(API.current.GetResults(gv.getParams()), gv.getTemplates());
                    URLCriteriaHelper.ConstructURL(gv.getParams(), gv.getAliasMapping());
                }
                gf.removeFilterPill(target_id);
            } else if (target_id.indexOf("jt_") >= 0) {
                var title = $(opts.el).find(".search-pill-name").text();
                var params = gv.getParams();
                var index = params.JobTitle.indexOf(title);
                if (index > -1) {
                    params.JobTitle.splice(index, 1);
                    params.Page = "1";
                    gv.setParams(params);
                    gf.display(API.current.GetResults(gv.getParams()), gv.getTemplates());
                    URLCriteriaHelper.ConstructURL(gv.getParams(), gv.getAliasMapping());
                }
                gf.removeFilterPill(target_id);
            } else if (target_id.indexOf("cwr_") >= 0) {
                var cyberWorkRole = target_id.split("cwr_")[1];
                var params = gv.getParams();
                var index = params.CyberWorkRole.indexOf(cyberWorkRole);
                if (index > -1) {
                    params.CyberWorkRole.splice(index, 1);
                    params.Page = "1";
                    gv.setParams(params);
                    gf.display(API.current.GetResults(gv.getParams()), gv.getTemplates());
                    URLCriteriaHelper.ConstructURL(gv.getParams(), gv.getAliasMapping());
                }
                gf.removeFilterPill(target_id);
            } else if (target_id.indexOf("cwg_") >= 0) {
                var cyberWorkGroup = target_id.split("cwg_")[1];
                var params = gv.getParams();
                var index = params.CyberWorkGrouping.indexOf(cyberWorkGroup);
                if (index > -1) {
                    params.CyberWorkGrouping.splice(index, 1);
                    params.Page = "1";
                    gv.setParams(params);
                    gf.display(API.current.GetResults(gv.getParams()), gv.getTemplates());
                    URLCriteriaHelper.ConstructURL(gv.getParams(), gv.getAliasMapping());
                }
                gf.removeFilterPill(target_id);
            } else if (target_id === "only_remote") {
                $("#only_remote").prop('checked', false);
                var params = gv.getParams();
                delete params.RemoteIndicator;
                gv.setParams(params);
                gf.display(API.current.GetResults(gv.getParams()), gv.getTemplates());
                URLCriteriaHelper.ConstructURL(gv.getParams(), gv.getAliasMapping());
                gf.removeFilterPill(target_id);
            } else if (target_id === "exclude_remote") {
                $("#exclude_remote").prop('checked', false);
                var params = gv.getParams();
                delete params.RemoteIndicator;
                gv.setParams(params);
                gf.display(API.current.GetResults(gv.getParams()), gv.getTemplates());
                URLCriteriaHelper.ConstructURL(gv.getParams(), gv.getAliasMapping());
                gf.removeFilterPill(target_id);
            }
            else {
                $('#' + target_id).click();
            }
        });

        $(document).on("click", "#search-pills-remove-all, #search-filters-remove-all", function (e) {
            gf.removeAllFilters();
            gf.removeAllSelections();
            if (gf.isIEorEdge()) {
                $(".usajobs-search-pills__list").css("height", "0");
            }
        });

        $(document).on("click", ".usajobs-search-filters__show-all-options", function (e) {
            e.preventDefault();
            if (usaj_ga) {
                usaj_ga.log_event('link', 'click', true, $(this));
            }
            var display = $(this).text().indexOf("Show") > -1 ? true : false;
            var dataID = $(this).data('id');
            var params = gv.getParams();
            if (display) {
                var dataID = $(this).data('id');
                params.ShowAllFilters.push(dataID);
            }
            else {
                var index = params.ShowAllFilters.indexOf(dataID);
                if (index != -1) params.ShowAllFilters.splice(index, 1);
            }
            gv.setParams(params);
            var hasJobs = false;
            $.each($(this).closest("div").find(".usajobs-search-filters__list"), function (index, value) {
                var header = $(this).prev(".usajobs-search-refiner__letter");
                if (header.length && header.hasClass("usaj-zero-jobs")) {
                    var groupID = $(this).prev(".usajobs-search-refiner__letter").data('id');
                    if (display) {
                        header.removeClass("usajobs-hidden");
                        $('.usajobs-search-refiner__jump-letter[data-id="' + groupID + '"]').removeClass('usajobs-search-link-disabled');
                    }
                    else {
                        header.addClass("usajobs-hidden");
                        $('.usajobs-search-refiner__jump-letter[data-id="' + groupID + '"]').addClass('usajobs-search-link-disabled');
                    }
                }
                $.each($(this).find(".usajobs-search-filters__item"), function (index, value) {
                    if ($(this).hasClass("usaj-zero-jobs")) {
                        if (display) $(this).removeClass("usajobs-hidden");
                        else $(this).addClass("usajobs-hidden");
                    } else { hasJobs = true; }
                });
            });

            
            $.each($(this).closest("div").find(".usajobs-search-filters-group"), function (index, value) {
                if ($(this).hasClass("usaj-zero-jobs")) {
                    var groupID = $(this).children(".usajobs-search-refiner__number").data('id');
                    if (display) {
                        $(this).removeClass("usajobs-hidden");
                        $('.usajobs-search-refiner__jump-number[data-id="' + groupID + '"]').removeClass('usajobs-search-link-disabled');
                    }
                    else {
                        $(this).addClass("usajobs-hidden");
                        $('.usajobs-search-refiner__jump-number[data-id="' + groupID + '"]').addClass('usajobs-search-link-disabled');
                    }
                } else { hasJobs = true; }
            });
         
            if ($(this).closest(".usajobs-search-refiner__container").length) {
                $(this).closest(".usajobs-search-refiner__container").find(".usajobs-search-filters__show-all-options").each(function () {
                    if (display) $(this).text("Hide options with 0 jobs");
                    else $(this).text("Show options with 0 jobs");
                });
                if (display) {
                    $(this).closest(".usajobs-search-refiner__container").find('a.usaj-zero-jobs').css('display', '');
                } else {
                    $(this).closest(".usajobs-search-refiner__container").find('a.usaj-zero-jobs').css('display', 'none');
                }
            } else {
                if (display) $(this).text("Hide options with 0 jobs");
                else $(this).text("Show options with 0 jobs");
            }
            gf.resetSelectAllByType($(this).data("filter"));
            URLCriteriaHelper.ConstructURL(gv.getParams(), gv.getAliasMapping());
        });

        $(document).on("click", ".usajobs-search-filter-grades__grade", function (event) {
            event.preventDefault();
        });

        $(document).on("search-filter.set-grade", "[data-object='search-filter']", function (event, opts) {
            var salaries, grade = opts.el.attr("data-value"), min_text = "(min GS", max_text = "(max GS",
                grade_table_state = $("#filter-pay-grades").attr("data-state"),
                state = opts.el.attr("data-state"),
                makeSalaries = function () {
                    var items = [],
                        min_range = gf.getSalaryRanges()[0],
                        max_range = gf.getSalaryRanges()[1],
                        $active = $(".usajobs-search-filter-grades").find("[data-behavior='search-filter.set-grade'][data-state='is-active']"),
                        all_min:number[] = [],
                        all_max:number[] = [];

                    if ($active !== undefined && $active.length > 0) {
                        $.each($active, function (idx, item) {
                            all_min.push(parseInt($(item).attr("data-salary-min") ?? "0", 10));
                            all_max.push(parseInt($(item).attr("data-salary-max") ?? "0", 10));
                        });
                    }

                    return {
                        findMin: function () {
                            var min_val;

                            if (all_min.length > 0) {
                                min_val = Math.min.apply(null, all_min);
                            } else {
                                min_val = min_range;
                            }

                            return min_val;
                        },
                        findMax: function () {
                            var max_val;

                            if (all_max.length > 0) {
                                max_val = Math.max.apply(null, all_max) > max_range ? max_range : Math.max.apply(null, all_max);
                            } else {
                                max_val = max_range;
                            }

                            return max_val;
                        }
                    };
                };
            event.preventDefault();
            if (grade_table_state === "is-active") {
                var params = gv.getParams();

                if (state === "is-active") {
                    opts.el.attr("data-state", "is-inactive");
                    params.GradeBucket.splice(params.GradeBucket.indexOf(opts.el.attr("data-value")), 1);
                } else {
                    opts.el.attr("data-state", "is-active");
                    params.GradeBucket.push(opts.el.attr("data-value"));
                }

                salaries = makeSalaries();
                var min_max = gf.findGradeMinMax();
                if (params.GradeBucket.length > 0) {
                    for (var x = min_max.min; x <= min_max.max; x++) {
                        $("#grade-" + x).attr("data-state", "is-active");
                        if (params.GradeBucket.indexOf(x.toString()) === -1) params.GradeBucket.push(x.toString());
                    }
                }

                if (min_max.min === 0) {
                    min_text += "<1";
                } else if (min_max.min === 16) {
                    min_text += ">15";
                } else {
                    min_text += " " + min_max.min;
                }
                min_text += ")";

                if (min_max.max === 16) {
                    max_text += ">15";
                } else if (min_max.max === 0) {
                    max_text += "<1";
                } else {
                    max_text += " " + min_max.max;
                }
                max_text += ")";

                $(".usajobs-search-filter-salary__min-GS").text(min_text);
                $(".usajobs-search-filter-salary__max-GS").text(max_text);

                var min = salaries.findMin(), max = salaries.findMax();
                params.RemunerationMinimumAmount = min;
                params.RemunerationMaximumAmount = max;
                $('#usajobs-salary-min').val(gf.formatSalary(min));
                $('#usajobs-salary-max').val(gf.formatSalary(max));
                $('#usajobs-salary-slider').slider("values", [min, max]);
                params.Page = "1";
                gv.setParams(params);
                
                var selected = false;
                $.each($("#filter-pay-grades .usajobs-search-filter-grades__item"), function () {
                    if ($(this).children().first().attr("data-state") === "is-active") {
                        selected = true;
                        return false;
                    }
                });
                
                if (selected) {
                    gf.createPillFromGrades();
                    gf.display(API.current.GetResults(gv.getParams()), gv.getTemplates(), event.target.id);
                    URLCriteriaHelper.ConstructURL(gv.getParams(), gv.getAliasMapping());
                } else {
                    gf.resetSalary();
                }
            }
        });

        $(document).on("search-pills.salary-reset", "[data-object='search-pills']", function (event, opts) {
            if ($(opts.el).hasClass("usajobs-branded-search-pills")) { return; }
            gf.resetSalary();
        });       

        $(document).on("search-filter.salary-reset", "[data-object='search-filter']", function (event, opts) {
            gf.resetSalary(false, event.target.id);
        });

        $(document).on("search-filter.remote-reset", "[data-object='search-filter']", function (event, opts) {
            gf.resetRemote();
        });
        $(document).on("change", "#usajobs-salary-min", function () {
            gf.validateMinAndMax("min");
            $('#usajobs-salary-slider').slider("values", 0, parseInt(($("#usajobs-salary-min").val() as string).replace(/\D/g, ''), 10));
        });

        $(document).on("keypress", "#usajobs-salary-min", function (event) {
            if (event.which == 13) {
                gf.validateMinAndMax("min");
                $('#usajobs-salary-slider').slider("values", 0, parseInt(($("#usajobs-salary-min").val() as string).replace(/\D/g, ''), 10));
            }
        });

        $(document).on("change", "#usajobs-salary-max", function () {
            gf.validateMinAndMax("max");
            $('#usajobs-salary-slider').slider("values", 1, parseInt(($("#usajobs-salary-max").val() as string).replace(/\D/g, ''), 10));
        });

        $(document).on("keypress", "#usajobs-salary-max", function (event) {
            if (event.which == 13) {
                gf.validateMinAndMax("max");
                $('#usajobs-salary-slider').slider("values", 1, parseInt(($("#usajobs-salary-max").val() as string).replace(/\D/g, ''), 10));
            }
        });

        $(document).on("keypress", "#usajobs-radius-min", function (event) {
            if (event.which == 13) {
                gf.validateRadius();
                $('#usajobs-radius-slider').slider("value", $('#usajobs-radius-min').val() as string);
            }
        });

        $(document).on("change", "#usajobs-radius-min", function (event) {
            gf.validateRadius();
            $('#usajobs-radius-slider').slider("value", $('#usajobs-radius-min').val() as string);
        });

        $(document).on("search-pills.distance-reset", "[data-object='search-pills']", function (event, opts) {
            gf.resetDistance();
        });

        $(document).on("search-filter.salary-enable", "[data-object='search-filter']", function (event, opts) {
            gf.enableSalary();
        });

        $(document).on("search-filter.salary-disable", "[data-object='search-filter']", function (event, opts) {
            gf.disableSalary();
        });

        $(document).on("search-filter.grades-enable", "[data-object='search-filter']", function (event, opts) {
            gf.enableGrades();
        });

        $(document).on("search-filter.grades-disable", "[data-object='search-filter']", function (event, opts) {
            gf.disableGrades();
        });

        $(document).on("search-pills.grade-reset", "[data-object='search-pills']", function (event, opts) {
            //reset salary calls reset grades
            gf.resetSalary();
        });

        $(document).on("click", "#search-save-cta", async function () {
            
            let emailFrequency: string = $(".usajobs-search-save__frequency").val() as string,
                $searchElement = $(".usajobs-search-save__name"),
                searchName = $searchElement.val() as string,
                query: Params = gv.getParams();

            if ($searchElement.closest("div").hasClass("usa-input-error")) {
                $searchElement.closest("div").removeClass("usa-input-error").find(".usa-input-error-message").remove();
            }

            if (searchName == "") {
                $searchElement.closest("div")
                    .addClass("usa-input-error")
                    .append('<span class="usa-input-error-message" id="input-error-message" role="alert">This field is required</span>')
            } else {
                let data = await API.current.SaveSearch(query, searchName, emailFrequency) as SavedSearchResult;
                $("#saveSearchErrorValidation").html("");

                if (data.searchID == 0) {
                    if (data.field) {
                        $('input[name="' + data.field + '"]').closest("div")
                            .addClass("usa-input-error")
                            .append('<span class="usa-input-error-message" id="input-error-message" role="alert">' + data.message + '</span>')
                    } else {
                        $("#saveSearchErrorValidation").append('<span class="usa-input-error-message" id="input-error-message" role="alert">' + data.message + '</span>')
                    }
                } else {
                    var savedSearchName = $searchElement.val() as string;
                    $searchElement.val("");
                    $(".view-search-name").text(data.message);  
                    $("#edit-search-name").text(data.message);
                    $('#save-search-name-success').html(data.message).closest(".usajobs-alert").removeClass("usaj-hidden");
                    $("#search-save").attr('aria-hidden', 'true');
                    $("#search-edit-display").show();
                    var updateParams = gv.getParams();
                    updateParams.SavedSearchID = data.searchID;
                    updateParams.SavedSearchName = savedSearchName;
                    gv.setParams(updateParams);
                    gv.setSavedSearchParams(JSON.stringify(updateParams));
                    gf.setSavedSearchTemplate(true);
                    $('#search-tab-bar-save').attr("aria-expanded", "false");
                    $("#search-prefs").addClass("usajobs-hidden");
                    gf.removePreferencePillsHighlight();
                }
            }
        });

        $(document).on("click", "#search-tab-bar-save", function (event) {
            event.preventDefault();
            $(".search-edit").show();
        });

        $(document).on("click", ".searchEditMode", function (event) {
            event.preventDefault();
            $("#SearchName").val('');
            $("#EmailFrequency").val('Daily');
            $("#search-save").attr('aria-hidden', 'false');
            $('#search-tab-bar-save').attr('aria-expanded', 'true');
            $("#search-edit-display").hide();
            $("#edit-form-container").hide();
            $("#edit-container").show();
        });

        $(document).on("click", "#search-cancel-edit", function (event) {
            let params: Params = gv.getParams();
            let userObject = JSON.parse(sessionStorage.getItem('userObject') ?? "");
            let IsAuthenticated: boolean = userObject && userObject.IsAuthenticated ? true : false;
            gv.setSavedSearchParams("null");
            gf.setSavedSearchTemplate(IsAuthenticated);
            gv.setParams(params);
            URLCriteriaHelper.ConstructURL(gv.getParams(), gv.getAliasMapping());
            $('#search-tab-bar-save').attr("aria-expanded", "false")
        });

        $(document).on("click", "#edit-form-container .usajobs-search-save__cancel", function (event) {
            $("#search-save").attr('aria-hidden', 'true');
            $("#search-edit-display").show(); 
        });

        $(document).on("click", "#search-update-cta", async function (event) {
            let savedSearchParams: string = gv.getSavedSearchParams();
            let params: Params = JSON.parse(savedSearchParams);
            let data = await API.current.UpdateSearch(gv.getParams(), params.SavedSearchID!) as SavedSearchResult;
            $("#saveSearchErrorValidation").html("");
            if (data.searchID == 0) {
                $("#saveSearchErrorValidation").append('<span class="usa-input-error-message" id="input-error-message" role="alert">' + data.message + '</span>');
            } else {
                $('#save-search-name-success').html(data.message).closest(".usajobs-alert").removeClass("usaj-hidden");
                $("#search-save").attr('aria-hidden', 'true');
                $('#search-tab-bar-save').attr("aria-expanded", "false")
                $("#search-edit-display").show();
            }
        });

        $(document).on("click", "#search-save-as-cta", function (event) {

            $("#edit-form-container").show();
            $("#edit-container").hide();
        });

        $(document).on('click', '[data-behavior]', function (event) {
            var $el = $(this),
                $object = $el.closest('[data-object="search-save"]'),
                behavior = $el.attr('data-behavior'),
                $target = $object.find('#' + $el.attr('aria-controls')),
                state = $el.attr('aria-expanded');

            $el.blur(); // Removes focus

            // Each behavior attached to the element should be triggered
            $.each(behavior?.split(' '), function (idx, action:string) {
                if (action.match(/^search-save/)) {
                    $el.trigger(action, { el: $el, object: $object, target: $target, state: state });
                }
            });
        });

        $(document).on('click', '.open-saved-search-nav', function (event) {
            
            $('#search-tab-bar-save').click();
        });

        $(document).on("click", '[data-behavior="search-save.open"]', function (event) {
            event.preventDefault();
        });

        $(document).on('search-save.open', function (event, opts) {
            if (opts.state === 'false') {
                $(".usajobs-search-save").attr('aria-hidden', 'false');
                opts.el.attr('aria-expanded', 'true');
            } else {
                $('.usajobs-search-save__input').removeClass("usa-input-error").find('#input-error-message').remove();
                $('#saveSearchErrorValidation').html("");
                $(".usajobs-search-save").attr('aria-hidden', 'true');
                opts.el.attr('aria-expanded', 'false');
            }
        });

        $(document).on('search-save-nav.close', function (event, opts) {
            var $tab_bar = $('[data-object="search-tab-bar"]'),
                $tab_bar_save_toggle = $tab_bar.find('[data-behavior="search-tab-bar.toggle-save-search"]');

            $('.usajobs-search-save__input').removeClass("usa-input-error").find('#input-error-message').remove();
            $('#saveSearchErrorValidation').html("");
            $(".usajobs-search-save").attr('aria-hidden', 'true');
            $('#search-save-toggle').attr('aria-expanded', 'false');
            $tab_bar_save_toggle.attr('aria-expanded', 'false');
        });

        $(document).on('click', '.keyword-suggestion', function () {
            var newKeyword = $(this).text();
            var params = gv.getParams();
            params.Keyword = newKeyword;
            gv.setParams(params);
            gf.display(API.current.GetResults(gv.getParams()), gv.getTemplates());
            URLCriteriaHelper.ConstructURL(gv.getParams(), gv.getAliasMapping());
            $("#nav-keyword").val(newKeyword);
            if (usaj_ga) {
                usaj_ga.simple_log_event('Keyword-Suggestion', 'select', newKeyword);
            }
        });

        $(document).ready(function () {
            //casting to get rid of the typescript error for the custom jQuery UI widget
            (<any>$("#nav-location")).locationAC({
                minLength: 2,
                source: usajSrcHighlighter,
                open: function () {
                    $(this).removeClass("ui-corner-all").addClass("ui-corner-top");
                    $("ul.ui-menu").width($(this).innerWidth() ?? 0);
                },
                select: function (event, ui) {
                    var params = gv.getParams();
                    if (ui.item.type === "remote jobs") {
                        if (params.RemoteIndicator == true && ui.item.actualValue == false) {
                            gf.removeFilterPill("only_remote");
                        }
                        else if (params.RemoteIndicator == false && ui.item.actualValue == true) {
                            gf.removeFilterPill("exclude_remote");
                        }
                        params.RemoteIndicator = ui.item.actualValue;
                        params.Page = "1";
                        gv.setParams(params);
                        gf.display(API.current.GetResults(gv.getParams()), gv.getTemplates());
                        URLCriteriaHelper.ConstructURL(gv.getParams(), gv.getAliasMapping());
                    }
                    else if (params.LocationName.indexOf(ui.item.value) == -1) {
                        params.LocationName.push(ui.item.value);
                        params.Page = "1";
                        gv.setParams(params);
                        gf.display(API.current.GetResults(gv.getParams()), gv.getTemplates());
                        URLCriteriaHelper.ConstructURL(gv.getParams(), gv.getAliasMapping());
                    }
                    logLocationAC(ui.item.value);
                    this.value = "";
                    return false;
                },
                close: function () {
                    $(this).removeClass("ui-corner-top").addClass("ui-corner-all");
                }
            }); 

            (<any>$("#nav-keyword")).keywordAC({
                source: keywordSrcHighlighter,
                minLength: 2,
                select: function (event, ui) {
                    var params = gv.getParams(),
                        selectedObj = ui.item;
                    $('#nav-keyword').val("");
                    switch (selectedObj.type) {
                        case "series":
                            if (selectedObj.parentName == "") {
                                params.JobCategoryFamily.push(selectedObj.actualValue);
                            } else {
                                params.JobCategoryCode.push(selectedObj.actualValue);
                            }
                            break;
                        case "agencies":
                            params.Agency.push(selectedObj.actualValue);
                            break;
                        case "departments":
                            params.Department.push(selectedObj.actualValue);
                            break;
                        case "occupations":
                            params.SocTitle.push(selectedObj.actualValue);
                            break;
                        case "job titles":
                            params.JobTitle.push(selectedObj.actualValue);
                            break;
                    }

                    params.Keyword = "";
                    params.Page = "1";

                    logKeywordAC(selectedObj.value);

                    params = gf.convertSeriesFamilyToSeries(params)
                    gv.setParams(params);
                    gf.display(API.current.GetResults(gv.getParams()), gv.getTemplates());
                    URLCriteriaHelper.ConstructURL(gv.getParams(), gv.getAliasMapping());

                    return false;
                },
                open: function () {
                    $(this).removeClass("ui-corner-all").addClass("ui-corner-top");
                    $("ul.ui-menu").width($(this).innerWidth() ?? 0);
                },
                close: function () {
                    $(this).removeClass("ui-corner-top").addClass("ui-corner-all");
                }
            })
        });

        $('#sort_attribute_mobile').on("change", function () {
            $('#sort_attribute').val($(this).val()!);
            $('#sort_attribute').trigger("change");
            $('html, body').animate({
                scrollTop: 0
            }, 'slow');
        });

        $(document).on("click", ".usajobs-search-controls__sort-results", function (e) {
            e.preventDefault();
            $("#search-tab-bar-sort").click();
        });

        $(document).on('click', '#usajobs-search-sort-close', e => {
            e.preventDefault();
            $("#search-tab-bar-sort").click();
        });

        $(document).on("click", "#sort-reset-mobile", function (e) {
            e.preventDefault();
            $("#sort_attribute_mobile").val("relevance").trigger("change");
        });

        $(document).ajaxStart(function () {
            $(".usajobs-search-results__loading").addClass('is-active');
        }).ajaxStop(function () {
            $(".usajobs-search-results__loading").removeClass('is-active');
        });

        $(window).on("popstate", function () {
            var params = URLCriteriaHelper.ParseURL(gv.getAliasMapping(), new Params());
            gv.setParams(params);
            $("#nav-keyword").val(params.Keyword ?? "");
            $("#search-pills-remove-all").hide();
            $(".usajobs-search-pills__item").remove();
            gf.display(API.current.GetResults(gv.getParams()), gv.getTemplates());
        });

        $(document).on('click', '.usajobs-search-refiner__jump-link', function (event) {
            event.preventDefault();
            var targetID = $(this).attr('data-href');
            var target = $(targetID!);
            var containerID = $(this).attr('data-target');
            var container = $(containerID!);            
            container.animate({
                scrollTop: (container.scrollTop() ?? 0) - container.offset()!.top + target.offset()!.top
            }, 500, function () {
                target[0]?.focus();
            });
        });

        $(document).on("click", "#search-prefs-toggle", function (event) {
            event.preventDefault();
            document.querySelector<HTMLElement>('#search-prefs-toggle')?.focus();
        });

        $(document).on("search-prefs.toggle", function (event, options) {
            var toggle = $("#search-prefs-toggle"), state = toggle.attr("data-state");
            if (state === "is-active") {
                gf.disableProfilePreferences();
                gf.removePreferencePills();
            } else {
                gf.enableProfilePreferences();
                gv.setProfileRemovedPreferences([]);
                gf.addPreferencePills();
            }
        });
        
        $(document).on("click", ".search-joa-link", function (event) {
            var params = gv.getParams();
            var startPage = params.Page;
            if (startPage === undefined) startPage = "1";
            var userObject: any = JSON.parse(sessionStorage.getItem('userObject') ?? "");
            if (userObject && userObject.UniqueSearch) {
                userObject.SearchResults = {};
                userObject.SearchResults.Params = params;
                userObject.SearchResults.Results = {};
                userObject.SearchResults.Results.Items = [];
                userObject.SearchResults.Results.ResultCount = gv.getJobCount();
                userObject.SearchResults.Results.ReturnUrl = window.location.href;
                userObject.SearchResults.SelectedDocumentId = $(this).attr('data-document-id') ?? "";
                userObject.SearchResults.ConversionId = crypto.randomUUID();
                if ($('#SSID').val() != "0") {
                    sessionStorage.setItem("profilePreferences", "false");
                }

                userObject.SearchResults.Results.PageSets = [];
                $.each($('.search-joa-link'), function (i, key) {
                    userObject.SearchResults.Results.Items.push($(key).data("document-id").toString())
                });
                userObject.SearchResults.Results.PageSets.push({
                    Page: Number(startPage),
                    PageItems: userObject.SearchResults.Results.Items
                });
                userObject.SearchResults.Params.ResultsPerPage = 25;
                sessionStorage.setItem('userObject', JSON.stringify(userObject));
                usaj_ga.log_search_conversion_event(userObject, "search_conversion_click");
            }
        });

        $(document).on("click", ".usajobs-search-refiner__number", function (event) {
            event.preventDefault();
            var id = $(this).attr("data-id"), params = gv.getParams(), checkedCount = $("#series-list-" + id).find("li input:checked").length,
                checkSize = $("#series-list-" + id).find("li input").length;
            if (checkedCount < checkSize) {
                $.each($("#series-list-" + id).find("li input:not(:checked)"), function () {
                    params.JobCategoryCode.push($(this).attr("data-id")!);
                });
            } else {
                $.each($("#series-list-" + id).find("li input"), function (index, input: HTMLElement) {
                    
                    params.JobCategoryCode.splice(params.JobCategoryCode.indexOf((input as HTMLInputElement).value), 1);
                    gf.removeFilterPill("series-" + (input as HTMLInputElement).value);
                });
            }
            gv.setParams(params);
            gf.display(API.current.GetResults(gv.getParams()), gv.getTemplates());
            URLCriteriaHelper.ConstructURL(gv.getParams(), gv.getAliasMapping());
        });

        $(document).on("click", ".usajobs-search-teaser__link", function () {
            if (usaj_ga) {
                usaj_ga.log_event_with_timeout("search teaser", "click", $('.usajobs-search-teaser').find('a').attr("href"));
            }
        });

        var preventDefaultList = [
            "#more-filters-tab",
            "#top-filters-tab",
            "#department-agency-filter",
            "#series-filter",
            ".usajobs-search-filters__see-more",
            ".usajobs-search-filter-nav__back",
            "#search-tab-bar-filter",
            "#search-tab-bar-sort",
            "#salary-reset",
            "#remote-reset"
        ]
        $(document).on("click", preventDefaultList.join(", "), function (event) {
            event.preventDefault();
        })
    }
}
